import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { setAdminKey } from "@/lib/auth";
import { API } from "@/lib/api";

export default function Login() {
  const [key, setKey] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/verify`, { key });
      setAdminKey(res.data.token);
      navigate("/admin/leads");
    } catch (err) {
      if (err?.response?.status === 503) {
        setError("Admin sign-in is unavailable because the server is not configured.");
      } else if (err?.response?.status === 429) {
        setError("Too many attempts. Please wait a minute and try again.");
      } else {
        setError("Invalid password.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <img src="/logo.png" alt="The Managerly" className="h-8 w-auto" />
          <span className="font-mono text-[10px] text-white/30">ADMIN</span>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="password"
            placeholder="Password"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            required
            className="w-full px-4 py-3 bg-white/5 border border-white/10 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#FF3B30]"
          />
          {error && <p className="text-[#FF3B30] text-sm">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-[#FF3B30] text-white text-sm tracking-wide hover:bg-[#E6352B] transition-colors disabled:opacity-50"
          >
            {loading ? "Verifying…" : "Sign in →"}
          </button>
        </form>
      </div>
    </div>
  );
}
